/** 人物 TXT 里的一笔贷款:出借方、本息、关联的房屋楼栋地块。 */
type Data = Record<string, any>;
const uint = (value: unknown): value is number => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 && value <= 0xffffffff;
const money = (value: unknown) => typeof value === 'number' && Number.isFinite(value) ? `${value.toFixed(2)} 元` : '未知';
const text = (value: unknown) => typeof value === 'string' && value.trim() ? value : '未知';
const known = (value: unknown) => value == null || value === '' ? '未知' : String(value);
const identity = (value: unknown) => uint(value) ? String(value) : '未知';
const associated = (value: unknown, label: string) => value === null ? `${label}：无` :
  value === undefined ? `${label}：未记录` : uint(value) ? `${label} #${value}` : `${label}：未记录`;

export function currentLoanText(loan: Data): string[] {
  const lender = loan.lender != null && typeof loan.lender === 'object' && !Array.isArray(loan.lender) ? loan.lender : null;
  const lenderText = lender?.kind === 'bank' ? `银行 ${text(lender.name)}（银行 #${identity(lender.id)}）` : lender ?
    `出借方 ${text(lender.name)}（原登记编号 ${uint(lender.id) ? `#${lender.id}` : '未知'} · 类型 ${text(lender.kind)}）` : '出借方 未知';
  const rate = typeof loan.rate === 'number' && Number.isFinite(loan.rate) ? `${loan.rate}%` : '未知';
  return [
    `贷款 #${identity(loan.id)} · ${text(loan.kind)} · ${lenderText} · 剩余本金 ${money(loan.principal)} · 年息 ${rate} · 合同每日本息 ${money(loan.pay)} · 连续逾期 ${uint(loan.missed) ? loan.missed : '未知'} 天`,
    `关联：${associated(loan.unit, '房屋')} · ${associated(loan.project, '楼栋/项目')} · ${associated(loan.plot, '地块')} · 对象说明 ${text(loan.what)}`,
    `原始本金 ${money(loan.originalPrincipal)} · 原始期限 ${known(loan.originalTerm)}`,
  ];
}
